import CoreAPI from "../coreAPI";
import CompanyDetails, { CompanyDetailsAPIResponse } from "../../classes/employerDashboard/companyDetails";

export default function APICompany(coreAPI: CoreAPI) {
  const api = {
    // This call will also fetch the logo if one has been uploaded
    async getCompanyDetails() {
      try {
        const response = await coreAPI.authCall<CompanyDetailsAPIResponse>({
          endpoint: `/tenant/company`,
        });
        return CompanyDetails.fromAPI({
          ...response,
        });
      } catch (e) {
        return null;
      }
    },
    async getCompanyLogo(logoFileName: string) {
      try {
        const response = await coreAPI.authCall<Blob>({
          endpoint: `/company/logo/${logoFileName}`,
          responseType: "blob",
        });
        return {
          url: URL.createObjectURL(response as any),
          size: response.size,
        };
      } catch (e) {
        return null;
      }
    },
    async removeCompanyLogo(logoFileName: string) {
      const response = await coreAPI.authCall<CompanyDetailsAPIResponse>({
        method: "DELETE",
        endpoint: `/company/logo/${logoFileName}`,
      });
      return CompanyDetails.fromAPI(response);
    },
    async uploadCompanyLogo(logo: File) {
      const formData = new FormData();
      formData.append("file", logo);
      formData.append("logoFileName", logo.name);
      const response = await coreAPI.authCall<CompanyDetailsAPIResponse>({
        method: "POST",
        endpoint: `/company/logo/${logo.name}`,
        body: formData,
      });
      return CompanyDetails.fromAPI(response);
    },
    async createCompanyDetails(details: CompanyDetails) {
      const response = await coreAPI.authCall<CompanyDetailsAPIResponse>({
        method: "POST",
        endpoint: "/company",
        body: details.toJSONForAPI(),
      });
      return CompanyDetails.fromAPI(response);
    },
    async updateCompanyDetails(details: CompanyDetails) {
      if (details.companyId === -1) return api.createCompanyDetails(details);
      const response = await coreAPI.authCall<CompanyDetailsAPIResponse>({
        method: "PATCH",
        endpoint: `/company/${details.companyId}`,
        body: details.toJSONForAPI(),
      });
      return CompanyDetails.fromAPI(response);
    },
    async removeCompanyDetails(details: CompanyDetails) {
      await coreAPI.authCall({
        method: "DELETE",
        endpoint: `/company/${details.companyId}`,
      });
      return true;
    },
  };
  return api;
}
